export default "__VITE_ASSET__Cb$nGetC__"